import { LoadingButton } from "@mui/lab";
import { ButtonProps } from "@mui/material";

import { useState } from "react";
import { useSearchParams } from "react-router-dom";

import { useAppDispatch } from "~/app/store";

import { loginAndon, loginQubit } from "~/features/login/login.slice";
import { mixpanelTrack, useMixpanelPageName } from "~/lib/mixpanel-tracking";

type OrganizationLoginButtonProps = {
  organizationName?: string;
} & ButtonProps;

export function OrganizationLoginButton(props: OrganizationLoginButtonProps) {
  const dispatch = useAppDispatch();
  const trackedPageName = useMixpanelPageName();
  const { organizationName, children, ...rest } = props;

  const [isLoading, setIsLoading] = useState(false);

  const [searchParams] = useSearchParams();

  const handleClick = async () => {
    setIsLoading(true);

    mixpanelTrack({
      trackedPageName,
      type: "Login",
      label: organizationName || ""
    });

    if (searchParams.get("andon-login") === "true") {
      await dispatch(
        loginAndon({
          authorizationParams: {
            organization: organizationName,
            prompt: "login"
          }
        })
      );
    } else {
      await dispatch(
        loginQubit({
          authorizationParams: {
            organization: organizationName,
            prompt: "login"
          }
        })
      );
    }

    setIsLoading(false);
  };

  return (
    <LoadingButton
      variant="contained"
      color="primary"
      id="login-button"
      disabled={!organizationName}
      onClick={handleClick}
      {...rest}
      loading={isLoading}
    >
      {children || "Login"}
    </LoadingButton>
  );
}
